import { LoadingOverlay } from '@mantine/core';
import { Navigate } from 'react-router-dom';

import useFetchUser from 'src/Hooks/Queries/useFetchUser';

const RequireTermsAccept = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isLoading } = useFetchUser();

  if (isLoading) {
    return (
      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
    );
  }

  if (user?.acceptedTermsPrivacy === false) {
    return <Navigate to="/accept-terms" replace />;
  }

  return children;
};

export default RequireTermsAccept;
